import {
  useEffect,
  useState,
} from 'react';
import {
  useUserSettings,
} from 'core/hooks';
import {
  FilterObjectType,
} from 'core/Filters/types';
import isNil from 'lodash/isNil';

export default function useFilterVersion(pageObject?: FilterObjectType) {
  const storageKey = `${pageObject}-filter-version`;
  const { version } = useUserSettings();
  const [
    isLocalSettingsInvalid,
    setIsLocalSettingsInvalid,
  ] = useState<boolean>(false);

  useEffect(() => {
    const localVersion = sessionStorage.getItem(storageKey);
    if (!isNil(version) && localVersion !== String(version)) {
      setIsLocalSettingsInvalid(true);
      sessionStorage.setItem(storageKey, String(version));
    }
  }, [version]);

  return isLocalSettingsInvalid;
}
